import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AzureAuthService } from 'src/service/azure-auth.service';

/** Restricts a route to users holding the role specified in the route's `data.role`. */
@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(
    private azureAuthService: AzureAuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const role = route.data?.role as string | undefined;
    if (!role || this.azureAuthService.isInRole(role) || this.azureAuthService.isAdmin()) {
      return true;
    }
    this.router.navigate(['/home']);
    return false;
  }
}
